import { ApiResponse, deleteRequest, postRequest } from "@/data/apiClient";
import { LoginResponse } from "@/data/repos/passwordLogin";

export const setSessionClient = (
  clientKey: string,
  code: string | undefined = undefined,
  app: string | undefined = undefined
): Promise<ApiResponse<string>> =>
  postRequest("user/sessionClient", { clientKey, code, app });

export const deleteSessionClient = (): Promise<ApiResponse<LoginResponse>> =>
  deleteRequest("user/sessionClient", {});
